(() => {
  const MIN_FILL_TIME_MS = 3000;
  const RESUBMIT_DELAY_MS = 30000;
  const MAX_LINKS = 3;
  const lastSubmitKey = 'overlayParadiseContactLastSubmit';

  const showMessage = (form, message) => {
    const output = form.querySelector('[data-contact-security-message]');
    if (!output) return;
    output.textContent = message;
    output.hidden = false;
  };

  document.querySelectorAll('[data-protected-contact-form]').forEach((form) => {
    const startedAt = Date.now();
    const startedInput = form.querySelector('[data-contact-started-at]');
    if (startedInput) startedInput.value = String(startedAt);

    form.addEventListener('submit', (event) => {
      const honeypot = form.querySelector('[data-contact-honeypot]');
      const body = form.querySelector('textarea[name="contact[body]"]');
      const submitButton = form.querySelector('button[type="submit"]');
      const elapsed = Date.now() - startedAt;
      const linkCount = (body?.value.match(/https?:\/\/|www\./gi) || []).length;
      const lastSubmit = Number(sessionStorage.getItem(lastSubmitKey) || 0);

      if (honeypot?.value.trim()) {
        event.preventDefault();
        showMessage(form, 'Your message could not be sent. Please refresh the page and try again.');
        return;
      }

      if (elapsed < MIN_FILL_TIME_MS) {
        event.preventDefault();
        showMessage(form, 'Please review your message before sending.');
        return;
      }

      if (linkCount > MAX_LINKS) {
        event.preventDefault();
        showMessage(form, 'Please include no more than three links.');
        return;
      }

      if (lastSubmit && Date.now() - lastSubmit < RESUBMIT_DELAY_MS) {
        event.preventDefault();
        showMessage(form, 'Please wait a moment before sending another message.');
        return;
      }

      sessionStorage.setItem(lastSubmitKey, String(Date.now()));
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }
    });
  });
})();
